export default __webpack_public_path__ + "static/media/diagnozowanie.1b9813b3.jpg";